import React, { cloneElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { IDialogWithId, useDialogs } from '../../../hooks/Dialogs';

export interface IDialogProps extends IDialogWithId {
}

function Dialog({ id, content, onClose }: IDialogProps) {
    const { closeDialog } = useDialogs();

    return (
        <div
            className='stx-dialog'
            onClick={e => e.stopPropagation()}>
            <div
                className='stx-dialog-window'
                style={{
                    backgroundColor: 'white'
                }}>
                <div
                    className='stx-dialog-close'
                    title={'zavřít'}
                    onClick={() => {
                        closeDialog(id);
                        onClose && onClose();
                    }}>
                    <FontAwesomeIcon
                        icon={icon({ name: 'xmark' })}
                        size='lg' />
                </div>
                <div className='stx-dialog-content'>
                    {cloneElement(content, { id })}
                </div>
            </div>
        </div>
    );
}

export default Dialog;
